import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let items = state.get('items') || Map(),
        id = parseInt(action.id, 10);

    items = items.set(
        id,
        (items.get(id) || Map())
            .set('state', 'IN_PROGRESS')
    );

    return state.set('items', items);
}

export function error(state, action) {
    let items = state.get('items') || Map(),
        id = parseInt(action.id, 10);

    items = items.set(
        id,
        (items.get(id) || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );

    return state.set('items', items);
}

export function finish(state, action) {
    let items = state.get('items') || Map(),
        id = parseInt(action.id, 10);

    items = items.set(
        id,
        (items.get(id) || Map())
            .merge(fromJS(action.event))
            .set('state', 'FINISHED')
    );

    return state.set('items', items);
}


export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    if (action.data) {
        action.data.forEach((event) => {
            let item = items.get(event.id) || Map();

            items = items.set(event.id, item.merge(event));
        });
    }

    return state.set('items', items);
}
